import React from "react";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Radium, { StyleRoot } from "radium";
import { fadeInRightBig } from "react-animations";
import { Img } from "react-image";

import buildingConcept from "./../../assets/images/building-torre-texao.png";
import "./sass/index.scss";

const styles = {
  fadeInRightBig: {
    animation: "x .5s",
    animationName: Radium.keyframes(fadeInRightBig, "fadeInRightBig"),
  },
  fadeInRightBig2: {
    animation: "x 1s",
    animationName: Radium.keyframes(fadeInRightBig, "fadeInRightBig"),
  },
};

class ConceptTorreTeaxo extends React.Component<any, any> {
  render() {
    return (
      <div className="cont-concept-project">
        <div className="con-text">
          <StyleRoot>
            <div style={styles.fadeInRightBig}>
              <div className="iconPlus" />
              <p>
                Un cuerpo macizo y pesado, se aligera, se extiende, se vuelve
                amigable al parque de en frente. Abstrae elementos de la fachada
                este del molino de Sabandía, y las reconfigura en líneas
                verticales y horizontales que componen la fachada. Ubicación:
                Umacollo, Arequipa.
              </p>
            </div>
          </StyleRoot>
        </div>
        <div className="cont-image">
          <StyleRoot>
            <div style={styles.fadeInRightBig2}>
              <Img
                src={buildingConcept}
                loader={
                  <div className="loader">
                    <FontAwesomeIcon icon={faSpinner} pulse />
                  </div>
                }
                alt=""
              />
            </div>
          </StyleRoot>
        </div>
      </div>
    );
  }
}

export default ConceptTorreTeaxo;
